// External libraries
import { useContext } from 'react';

// Context
import { ViewportSizeContext } from '../context/viewportSizeContext';

export default function useViewportSize() {
  return useContext(ViewportSizeContext);
}
